import { Tooltip, Typography, TypographyProps } from "@mui/material";
import React from "react";
import { ellipsisText } from "../utils/formatText";

const TextEllipsisWithTooltip = ({
  text,
  maxLength,
  noTooltip = false,
  ...props
}: { text: string; maxLength: number; noTooltip?: boolean } & TypographyProps) => {
  return (
    <Tooltip
      title={text.length > maxLength && !noTooltip ? <Typography variant="body2">{text}</Typography> : undefined}
      arrow
    >
      <Typography {...props}>{ellipsisText(text, maxLength)}</Typography>
    </Tooltip>
  );
};

export default TextEllipsisWithTooltip;
